









































































































































































































































































































































import {Vue, Prop, Watch, Emit} from "vue-property-decorator";
import Component from "vue-class-component";
import './_details-page.less';
import $ from 'jquery';
import {
    get,
    getCalculationData,
    getCalculatorDetails,
    getCalculatorProduct
} from '../../services/webclient/webclient';
import progressbar from '../progressbar/progressbar.vue';
import {string} from "prop-types";
import {getPdf} from "../../services/webclient/webclient";
import {translate} from "../../services/translation/translation";

require("../../../node_modules/corejs-typeahead/dist/typeahead.bundle.js");
import Bloodhound from '../../../node_modules/bloodhound-js/lib/bloodhound.js'
import detailsColorPicker from "@/components/details-color-picker/details-color-picker.vue";
import loader from "@/components/loader/loader.vue";
import {goToTop} from "@/services/position/position";


@Component({
    components: {
        progressbar,
        detailsColorPicker,
        loader,
    }
})
export default class detailsPage extends Vue {
    @Prop() selectedAnswer;
    @Prop() selectedCalcId;
    @Prop() systemId;
    @Prop() sendingAnswerData;
    @Prop() selectedName;
    @Prop() resetQuestionEngine;

    @Prop() calculatorDefaulSettings;
    @Prop() calculatorDefaulSystem;
    @Prop() setting;
    @Prop() colorPaletta;
    @Prop() isShowPrices;


    /*
    * product nem kérem
      products[13][product_id]: -1
      products[13][variant_id]: -1
      products[13][area]: 60
    * */
    private data: any = {
        progressbar: {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'active',
            'step3': ''
        },
        yourData: {},
        questionData: {},
        sections: [],
        dataTemp: [],
        totalPrice: 0,
        sendingProductsData: {},
        timer: {}

    };
    private isCalculationDataOpen = false;
    private calculationDataIcon = "keyboard_arrow_down";
    private calculationDataText = "Calculation data";
    private view_compact = "active";
    private view_comfy = "";
    private tableView = "";
    private isLoadedYourData = false;
    private isLoadedDetails = false;

    beforeCreated() {
    }

    created() {
    }

    mounted() {
        goToTop('calculator-container', '');

    }

    activated() {
        goToTop('calculator-container', '');
        this.getCalculationData();
        this.getDetails();
    }

    trans(key) {
        return translate(key);
    }

    log(v){
        console.log(v);
    }

    isExistDisplay(attributes: any) {
        if (typeof attributes == undefined  || attributes == null || attributes == '') {
            return '';
        } else {
            return attributes;
        }
    }
    isExist(attributes: any) {
        if (typeof attributes == undefined  || attributes == null || attributes == '') {
            return false;
        } else {
            return true;
        }
    }

    initTypheadSearch(colorPalette) {
        var self = this;
        var list = [];
        colorPalette.forEach(function (value, index) {
            if (typeof value.name !== "undefined") {
                list[index] = value.name;
            }
        });

        function colorPaletteWhiteDefaults(q, sync) {
            if (q === '') {
                sync(colorPaletteBloodhound.get(list));
            } else {
                colorPaletteBloodhound.search(q, sync);
            }
        }


        var colorPaletteBloodhound = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            identify: function (obj) {
                return obj.name;
            },
            local: colorPalette
        });

        $('.' + this.typheadClass).typeahead({
                hint: false,
                highlight: true,
                minLength: 0,
            },
            {

                limit: 10000,
                display: 'name',
                name: 'name',
                source: colorPaletteWhiteDefaults,
                templates: {
                    suggestion: function (data) {
                        if (data.hex == null) {
                            return '<div class="color-select-option"><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-image: url(' + data.image + ')"></div></div>';

                        } else {
                            return '<div class="color-select-option"><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-color: #' + data.hex + '"></div></div>';

                        }
                    }
                }
            }).on('typeahead:select', function (e, o) {

            $(e.currentTarget).val(o.name);
            if (o.hex == null) {
                $(e.currentTarget).css("background-image", "url(" + o.image + ")");
                self.onSelectedFootingColor(o.id);
            } else {
                $(e.currentTarget).css("background-color", "#" + o.hex);
                self.onSelectedFacadeColor(o.id);
            }

        }).on('keyup', function () {
            if ($(this).val().length < 4) {
                $(this).removeAttr('style');
            }
        });
    }



    getDetails() {
        this.isLoadedYourData = false;
        let t = {};
        t['data'] = this.getSendData();
        t['system_id'] = this.systemId;
        getCalculatorDetails(t, this.selectedCalcId).then(data => {
            this.data.sections = data.sections;
            this.data.totalPrice = data.totalPrice;
            this.data.TotalPriceWithVat = data.TotalPriceWithVat;
            this.data.totalVat = data.totalVat;
            this.createProductsSendingData(data.sections);
            this.isLoadedYourData = true;
        }).catch(err => console.warn(err));
    }

    updateDetails(isUpdateDetailsProductArea = false) {
        this.isLoadedDetails =false;
        if(isUpdateDetailsProductArea){
            this.updateDetailsProductArea();
        }
        let t = {};
        t['data'] = this.getSendYourData();
        t['system_id'] = this.systemId;
        t['products'] = this.data.sendingProductsData;
        getCalculatorDetails(t, this.selectedCalcId).then(data => {
            this.data.sections = data.sections;
            this.data.totalPrice = data.totalPrice;
            this.data.TotalPriceWithVat = data.TotalPriceWithVat;
            this.data.totalVat = data.totalVat;
            this.createProductsSendingData(data.sections);
            this.isLoadedDetails =true;
        }).catch(err => console.warn(err));
    }

    updateDetailsProductArea(){
        let self = this;
        $.each(this.data.yourData.rows, function (index, row) {
            $.each(row.items, function (index, item) {
                console.log();
                if(item.name== 'area'){
                    $.each(item.updateProductTypes, function (index, updateProductType) {
                        $.each(self.data.sendingProductsData, function (index, productData) {
                            if(updateProductType == index){
                                productData.area = item.value;
                            }
                        });
                    });
                }
                if(item.name== 'facade_area'){
                    $.each(item.updateProductTypes, function (index, updateProductType) {
                        $.each(self.data.sendingProductsData, function (index, productData) {
                            if(updateProductType == index){
                                productData.area = item.value;
                            }
                        });
                    });
                }
                if(item.name== 'footing_area'){
                    $.each(item.updateProductTypes, function (index, updateProductType) {
                        $.each(self.data.sendingProductsData, function (index, productData) {
                            if(updateProductType == index){
                                productData.area = item.value;
                            }
                        });
                    });
                }
            })
        })
    }

    getCalculationData() {
        let t = {};
        t['data'] = this.getSendData();
        t['system_id'] = this.systemId;
        getCalculationData(t, this.selectedCalcId).then(data => {
            this.data.yourData = data;
            this.isLoadedDetails = true;
            this.getSendYourData();
        }).catch(err => console.warn(err));
    }

    getSendData() {
        let dataTemp = [];

        $.each(this.selectedAnswer, function (index, question) {
            let obj = {};
            obj['id'] = question.id;
            obj['name'] = question.name;
            if(question.type == 'radio-group'){
                obj['answer'] = {};
                obj['answer']['id'] = question.value_id;
                obj['answer']['value'] = question.value;
            }else if(question.type == 'checkbox-group'){
                obj['answer'] = {};
                obj['answer']['id'] =[];
                $.each(question.value, function (index, value) {
                    obj['answer']['id'].push(value.id);
                })

            }else{
                obj['answer'] = question.value;
            }
            dataTemp.push(obj);
        });

        this.data.questionData = dataTemp;
        return dataTemp;
    }
    getSendYourData() {
       let dataTemp = [];
        $.each(this.data.yourData.rows, function (index, row) {
            $.each(row.items, function (i, item) {
                if(item.type == "text"){
                    let obj = {};
                    obj['id'] = item.id;
                    obj['answer'] = item.value;
                    dataTemp.push(obj);
                }else if(item.type == "colorpicker" && false){
                    let obj = {};
                    obj['id'] = item.id;
                    obj['answer'] = item.selectedColor;
                    dataTemp.push(obj);
                }else if(item.type == "select" ){
                    let obj = {};
                    obj['id'] = item.id;
                    obj['answer'] = item.selectedValue!= null && item.selectedValue != ''? item.selectedValue: '';
                    dataTemp.push(obj);
                }
            })

        });

        /*merge and update AnswerData and Your date*/
        let mergeArray = [];

        mergeArray = Object.values(this.sendingAnswerData);
       $.each(dataTemp, function (questionDataIndex, question) {
            let isFound = false;
            $.each(mergeArray, function (tesztIndex, data) {
                if(data.id == question.id){
                    data.answer = question.answer;
                    isFound = true;
                }
            });
            if(!isFound){
                mergeArray.push(question)
            }
        });

        this.onSendYourData(mergeArray);

        return mergeArray;
    }

    createProductsSendingData(data){
        let self = this;
        $.each(data, function (index, section) {
            if(section.items.length > 0){
                $.each(section.items, function (ind, product) {
                    let productTypeId = product.products[0].product_type.id;

                    self.data.sendingProductsData[productTypeId] = {};
                    self.data.sendingProductsData[productTypeId]['product_id'] = product.selectedProduct.id;
                    self.data.sendingProductsData[productTypeId]['variant_id'] = product.selectedVariant.id;
                    self.data.sendingProductsData[productTypeId]['area'] = product.area;

                });
            }
        });


        this.onSendProducts(this.data.sendingProductsData);
    }


    selectProductOption(productTypeId, productId, variantId, itemArea){
        this.data.sendingProductsData[productTypeId].product_id = productId;
        this.data.sendingProductsData[productTypeId].variant_id = variantId;
        this.data.sendingProductsData[productTypeId].area = itemArea;
        this.onSendProducts(this.data.sendingProductsData);
        this.updateDetails();
    }

    selectProductOptionWhiteTimer(productTypeId, productId, variantId, itemArea){
        let self = this;
        clearTimeout(this.data.timer);
        this.data.timer  = setTimeout(function () {
            self.selectProductOption(productTypeId, productId, variantId, itemArea)
        }, 2000);
    }


    onChangeTableView(toogle) {
        if (toogle == 'open') {
            this.tableView = "extended";
            this.view_comfy = "active";
            this.view_compact = "";
            $('.colspan-this-total-price').attr('colspan', 6);
        } else {
            this.tableView = "";
            this.view_comfy = "";
            this.view_compact = "active";
            $('.colspan-this-total-price').attr('colspan', 3);
        }

    }


    onChangeCalculationDataOpenClose() {
        if (this.isCalculationDataOpen) {
            this.isCalculationDataOpen = false;
            this.calculationDataIcon = "keyboard_arrow_down";
            this.calculationDataText = "Calculation data";
        } else {
            this.isCalculationDataOpen = true;
            this.calculationDataIcon = "keyboard_arrow_up";
            this.calculationDataText = "Your data";

        }
    }

    getTitleClass(title) {
        if (title == "") {
            return 'd-none';
        } else {
            return 'col-md-2 col-12';
        }
    }

    getDateClass(title) {
        if (title == "") {
            return 'col-md-12 col-12 row';
        } else {
            return 'col-md-10 col-12 row';
        }
    }

    getUnit(unit){
        if(unit == 'm2'){
            return 'm<sup>2</sup>';
        }else{
            return unit;
        }
    }

    @Watch("selectedColor", {immediate: true, deep: true})
    onSelectedColor(inputId, colorId) {
        if (colorId !== undefined) {
        }
    }


    goToDiscountsWhiteSystem(value){
        let t = {};
        t['data'] = this.getSendYourData();
        t['system_id'] = this.systemId;
        t['products'] = this.data.sendingProductsData;
        this.goToDiscounts(t);
    }

    getPDFCall(){
        let data = {};
        data['previewPDF'] = '1';
        data['data'] = this.getSendYourData();
        data['system_id'] = this.systemId;
        data['products'] = this.data.sendingProductsData;
        getPdf(this.selectedCalcId, data).then(data => {
            // console.log(data)
        }).catch(err => console.warn(err));
    }

    @Emit("backToProduct")
    backToProduct(systems) {
    }


    @Emit("goToDiscounts")
    goToDiscounts(systems) {
    }

    @Emit("sendYourData")
    onSendYourData(data) {
    }
    @Emit("sendProducts")
    onSendProducts(data) {
    }
}
